import { useContext } from "react";
import { NavContext } from "./NavContext";

export const useAdminBar = () => {
  const [{ hasAdminBar }] = useContext(NavContext);
  return { hasAdminBar };
};
